import { GET, POST, DELETE, PUT, PATCH, POSTFORM } from './Network.js'
import { ToastNone, ToastErrors } from './Toast.js'

// const PreferencesToast = ToastErrors

export const  API = {
  auth: {
    status:           GET('/auth/status', ToastNone),
    refresh:          GET('/auth/refresh', ToastNone),
    jwt:              GET('/auth/jwt'),
    login:            POST('/auth/login'),
    logout:           POST('/auth/logout'),
    logoutAll:        POST('/auth/logout-all'),
    register:         POST('/auth/register'),
    registerPIN:      POST('/auth/register-pin'),
    registerAccept:   POST('/auth/register-accept'),
    recovery:         POST('/auth/recovery'),
    recoveryPIN:      POST('/auth/recovery-pin'),
    recoveryAccept:   POST('/auth/recovery-accept'),
    xauth:            POST('/auth/xauth'),
    laravel:          POST('/auth/xauth-laravel')
  },
  autocomplete: {
    company:          GET('/autocomplete/company', ToastErrors),
    scheme:           GET('/autocomplete/scheme', ToastErrors),
    property:         GET('/autocomplete/property', ToastErrors),
  },
  enquiry: {
    property:         POST('/enquiry/property'),
    // for now both property and scheme enquiries are handled through the
    // same endpoint, passing a different property_type parameter
    scheme:           POST('/enquiry/property')
  },
  collector: {
    correction:       POST('/collector/correction', ToastNone)
  },
  singleProperty: {
    upload:           POST('/singleProperty/upload'),
    email:            POST('/singleProperty/email'),
    confirmation:     POST('/singleProperty/confirmation'),
    stripe:           POST('/singleProperty/stripe'),
  },
  saved_search: {
    list:             GET('/saved-search', ToastNone),
    delete:           DELETE( params => `/saved-search/${params.id}`),
    context: {
      list:           GET( params => `/saved-search/context/${params.context}`, ToastNone),
      // add:            POST( params => `/saved-search/context/${params.context}`, ToastNone),
      // TODO: Ideally this would use context from the params, but the api fails wheb the params includes context
      add:            POST( params => `/saved-search/context/${params.context}`, ToastNone),
      update:         POST( params => `/saved-search/${params.id}`, ToastNone),
      delete:         DELETE(params => `/saved-search/${params.id}`),

    }

  },
  rating: {
    lists:            GET('/ratings', ToastNone),
    contextType: {
      list:           GET( params => `/ratings/${params.context_type}`, ToastNone),
      put:            PUT( params => `/ratings/${params.context_type}`, ToastNone),
    },
    contextTypeId: {
      list:           GET( params => `/ratings/${params.context_type}/${params.context_id}`, ToastNone),
      put:            PUT( params => `/ratings/${params.context_type}/${params.context_id}`, ToastNone),
    }
  },
  oauth: {
    google:           POST('/oauth/google', ToastNone),
  },
  user: {
    profile:          GET('/user/profile'),
    details:          POST('/user/details'),
    password:         POST('/user/password'),
    avatar: {
      add:            POSTFORM('/user/avatar'),
      delete:         DELETE('/user/avatar'),
    },
    company: {
      add:            POST('/user/company'),
      edit:           PUT( params => `/user/company/${params.company_id}` ),
      select:         POST( params => `/user/company/${params.company_id}/select` ),
      delete:         DELETE( params => `/user/company/${params.company_id}` ),
    },
    contact: {
      add:            POST('/user/contact'),
      edit:           PUT( params => `/user/contact/${params.contact_id}` ),
      delete:         DELETE( params => `/user/contact/${params.contact_id}` ),
    },
    email: {
      add:            POST('/user/email'),
      select:         POST('/user/email/select'),
      validate:       POST('/user/email/validate'),
      delete:         POST('/user/email/delete'),
    },
    website: {
      add:            POST('/user/website'),
      edit:           PUT( params => `/user/website/${params.name}` ),
      delete:         DELETE( params => `/user/website/${params.name}` ),
    },
    preference: {
      activity: {
        add:          POST( params => `/user/preference/activity/${params.activity_id}` ),
        delete:       DELETE( params => `/user/preference/activity/${params.activity_id}` ),
      },
      market: {
        add:          POST( params => `/user/preference/market/${params.market_id}` ),
        delete:       DELETE( params => `/user/preference/market/${params.market_id}` ),
      },
      email: {
        add:          POST( params => `/user/preference/email/${params.preference}` ),
        delete:       DELETE( params => `/user/preference/email/${params.preference}` ),
      }
    },
  },
  jwt: {
    sign: GET('/test/jwt/status')
  }
}

export default API